import React, { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSetMultipleParams } from "../../hooks/useSetMultipleParams";

function CardId({ id, boardKey, boardId }) {
  const [setMultipleSearchParams] = useSetMultipleParams();

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const handleOpenCardDetail = useCallback(
    (boardId, cardId) => {
      setMultipleSearchParams([
        {
          name: "brd_id",
          value: boardId,
        },
        {
          name: "card_id",
          value: cardId,
        },
      ]);
    },
    [setMultipleSearchParams, id]);
  const handleClick = useCallback(
    (event) => {
      if (location.pathname.includes("/watching")) {
        handleOpenCardDetail(boardId, id);
        return;
      }
      const isModifierPressed = event.metaKey || event.ctrlKey || event.shiftKey;
      const params = new URLSearchParams(searchParams);
      const url = `/board/${boardKey}/${boardKey}-${id}?${params.toString()}`;

      if (isModifierPressed) {
        window.open(url, "_blank");
        event.stopPropagation();
        return;
      }
      navigate(url);
    },
    [searchParams,id]
  );


  return (
    <div>
      <p
        className="card-anchor size-14"
        onClick={(event) => handleClick(event)}
      >
        {boardKey}-{id}
      </p>
    </div>
  );
}

export default React.memo(CardId);
